import React, { useState, useEffect } from "react";
import NetworkRole from "./NetworkRole/NetworkRole";
import Button from "../../../ResuableCompoment/Button";
import { useSelector } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import Popup from "../../../ResuableCompoment/Popup";
import { useLocation } from "react-router-dom";

const MappingCommission = () => {
  const location = useLocation();

  const merchantFormData = useSelector((state) => state.auth.merchantFormData);
  console.log("sdbjbjbdjbksds", merchantFormData)
  const userId = useSelector((state) => state.auth.employeeDetails?.userId);
  const formDataFromTable = location.state?.formDataFromTable;

  const [selectedRole, setSelectedRole] = useState("");
  const [parentId, setParentId] = useState(null);
  const [isVideoUploaded, setIsVideoUploaded] = useState(false);

  const [fullLoading, setFullLoading] = useState(false);
  const [halfLoading, setHalfLoading] = useState(false);

  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [navigateTo, setNavigateTo] = useState(null);

  const showPopupMessage = (msg, type, nav = null) => {
    setPopupMessage(msg);
    setPopupType(type);
    setNavigateTo(nav);
    setShowPopup(true);
  };

  const { callApi } = useApi(
    `/staff/onboard/signup${parentId ? `?parentId=${parentId}` : ""}`,
    "POST"
  );

  const { callApi: callWalletApi } = useApi(
    "/business/wallet/create/v1",
    "POST"
  );

  const { callApi: callAddAgentApi } = useApi(
    "/aeps/eazypay/add-agent",
    "POST"
  );

  /* ---------------- PREFILL ---------------- */
  useEffect(() => {
    if (formDataFromTable) {
      setSelectedRole(formDataFromTable.role || "");
      setParentId(formDataFromTable.parentId || null);
    }
  }, [formDataFromTable]);

  /* ---------------- VIDEO CHECK ---------------- */
  useEffect(() => {
    const hasFiles =
      merchantFormData?.videouploadDocuments &&
      Object.keys(merchantFormData.videouploadDocuments).length > 0;

    setIsVideoUploaded(hasFiles);
  }, [merchantFormData]);

  /* ================= FULL ONBOARDING ================= */
  //   const handleSubmitfull = async () => {
  //     if (!selectedRole || !parentId) {
  //       showPopupMessage("Please select role & parent", "error");
  //       return;
  //     }

  //     setFullLoading(true);

  //     try {
  //       const formData = new FormData();

  //       const {
  //         basicDetails,
  //         aadhaarDetails,
  //         accountDetails,
  //         shopDetails,
  //         uploadDocuments,
  //         videouploadDocuments,
  //       } = merchantFormData;

  //       /* ---- BASIC DETAILS ---- */
  //       formData.append("username", basicDetails.username);
  //       formData.append("email", basicDetails.email);
  //       formData.append("mobileNumber", basicDetails.mobileNumber);
  //       formData.append("panCard", basicDetails.panNumber);
  //       formData.append("password", basicDetails.password);
  //       formData.append("confirmPassword", basicDetails.confirmPassword);
  //       formData.append("role", selectedRole);
  //       formData.append("fullName", basicDetails.fullName);
  //       formData.append("fatherName", basicDetails.fatherName);
  //       formData.append("dob", basicDetails.dob);
  //       formData.append("gender", basicDetails.gender);

  //       /* ---- AADHAAR ---- */
  //       formData.append("aadharNumber", aadhaarDetails.aadharNumber);
  //       formData.append("aadharAddress", aadhaarDetails.houseAddress);
  //       formData.append("aadharState", aadhaarDetails.state);
  //       formData.append("aadharDistrict", aadhaarDetails.district);
  //       formData.append("aadharPinCode", aadhaarDetails.pincode);
  //       formData.append("landmark", aadhaarDetails.landmark);

  //       /* ---- BANK ---- */
  //       formData.append("accountNumber", accountDetails.accountNumber);
  //       formData.append("ifscCode", accountDetails.ifscCode);
  //       formData.append("bankName", accountDetails.bankName);
  //       formData.append("accountHolderName", accountDetails.accountHolderName);

  //       /* ---- SHOP ---- */
  //       formData.append("shopName", shopDetails.shopName);
  //       formData.append("shopAddress", shopDetails.shopAddress);
  //       formData.append("shopState", shopDetails.state);
  //       formData.append("shopDistrict", shopDetails.district);
  //       formData.append("shopPinCode", shopDetails.pincode);
  //       formData.append("shopLandmark", shopDetails.landmark);

  //       formData.append("onboardingStatus", "FULL");
  //       formData.append("createdBy", userId);

  //       /* ---- UPLOAD DOCUMENTS (FULL) ---- */
  //       const fileKeys = [
  //         "aadhaarBack",
  //         "aadhaarFront",
  //         "panCard",
  //         "passbookOrChequeBook",
  //         "selfieWithDocuments",
  //         "selfieWithSalesPerson",
  //         "shopPhoto",
  //         "signaturePhoto",
  //         "Biometricdevice",
  //         "VideoaadhaarBack",
  //         "VideoaadhaarFront",
  //         "VideopanCard",
  //         "VideoshopPhoto",
  //         "optional1",
  //         "optional2",
  //       ];

  //       const filesArray = [];

  //       if (uploadDocuments) {
  //         fileKeys.forEach((key) => {
  //           if (uploadDocuments[key] instanceof File) {
  //             filesArray.push({ key, file: uploadDocuments[key] });
  //           }
  //         });
  //       }

  //       if (videouploadDocuments) {
  //         fileKeys.forEach((key) => {
  //           if (videouploadDocuments[key] instanceof File) {
  //             filesArray.push({ key, file: videouploadDocuments[key] });
  //           }
  //         });
  //       }

  //       filesArray.forEach(({ key, file }) => {
  //         formData.append(`kycFiles[${key}]`, file);
  //       });

  //       const response = await callApi(formData);

  //       if (response?.user_id) {
  //         const walletResponse = await callWalletApi({
  //           mid: basicDetails.username,
  //           account_no: accountDetails.accountNumber,
  //           currency: "INR",
  //           business_type: selectedRole,
  //         });

  //         showPopupMessage(
  //           `FULL ONBOARDING SUCCESS
  // User ID: ${response.user_id}
  // Wallet: ${walletResponse?.message}`,
  //           "success",
  //           "/OnboardingBasicDetails"
  //         );
  //       }
  //     } catch (err) {
  //       showPopupMessage("Full onboarding failed", "error");
  //     } finally {
  //       setFullLoading(false);
  //     }
  //   };


  const handleSubmitfull = async () => {
    if (!selectedRole || !parentId) {
      showPopupMessage("Please select role & parent", "error");
      return;
    }

    setFullLoading(true);

    try {
      const formData = new FormData();

      const {
        basicDetails,
        aadhaarDetails,
        accountDetails,
        shopDetails,
        uploadDocuments,
        videouploadDocuments,
      } = merchantFormData;

      /* ---- BASIC DETAILS ---- */
      formData.append("email", basicDetails.email);
      formData.append("mobileNumber", basicDetails.mobileNumber);
      formData.append("panCard", basicDetails.panNumber);
      formData.append("role", selectedRole);
      formData.append("fullName", basicDetails.fullName);
      formData.append("fatherName", basicDetails.fatherName);
      formData.append("dob", basicDetails.dob);
      formData.append("gender", basicDetails.gender);

      /* ---- AADHAAR ---- */
      formData.append("aadharNumber", aadhaarDetails.aadharNumber);
      formData.append("aadharAddress", aadhaarDetails.houseAddress);
      formData.append("aadharState", aadhaarDetails.state);
      formData.append("aadharDistrict", aadhaarDetails.district);
      formData.append("aadharPinCode", aadhaarDetails.pincode);
      formData.append("landmark", aadhaarDetails.landmark);

      /* ---- BANK ---- */
      formData.append("accountNumber", accountDetails.accountNumber);
      formData.append("ifscCode", accountDetails.ifscCode);
      formData.append("bankName", accountDetails.bankName);
      formData.append("accountHolderName", accountDetails.accountHolderName);

      /* ---- SHOP ---- */
      formData.append("shopName", shopDetails.shopName);
      formData.append("shopAddress", shopDetails.shopAddress);
      formData.append("shopState", shopDetails.state);
      formData.append("shopDistrict", shopDetails.district);
      formData.append("shopPinCode", shopDetails.pincode);
      formData.append("shopLandmark", shopDetails.landmark);
      formData.append("gst", shopDetails.gstNumber);
      formData.append("gstTradeName", shopDetails.gstTradeName);

      formData.append("onboardingStatus", "FULL");
      formData.append("createdBy", userId);

      /* ---- FILES ---- */
      const fileKeys = [
        "aadhaarBack",
        "aadhaarFront",
        "panCard",
        "passbookOrChequeBook",
        "selfieWithDocuments",
        "selfieWithSalesPerson",
        "shopPhoto",
        "signaturePhoto",
        "gstcertificate",
        "Biometricdevice",
        "VideoaadhaarBack",
        "VideoaadhaarFront",
        "VideopanCard",
        "VideoshopPhoto",
        "optional1",
        "optional2",
      ];

      [...fileKeys].forEach((key) => {
        if (uploadDocuments?.[key] instanceof File) {
          formData.append(`kycFiles[${key}]`, uploadDocuments[key]);
        }
        if (videouploadDocuments?.[key] instanceof File) {
          formData.append(`kycFiles[${key}]`, videouploadDocuments[key]);
        }
      });

      /* ---- MERCHANT CREATE ---- */
      const response = await callApi(formData);

      if (!response?.user_id) {
        showPopupMessage(
          response?.message || "Merchant creation failed",
          "error"
        );
        return; // ❌ STOP HERE
      }

      /* ---- WALLET CREATE ---- */
      try {

        const allowedRoles = ["MERCHANT", "INDEPENDENT_MERCHANT"];

        if (allowedRoles.includes(selectedRole)) {
          try {
            await callAddAgentApi({
              contactPerson: basicDetails.fullName,
              mobile: basicDetails.mobileNumber,
              shopAddress: shopDetails.shopAddress,
              shopName: shopDetails.shopName,
              panCard: basicDetails.panNumber,
              aadharCard: aadhaarDetails.aadharNumber,
              dob: basicDetails.dob,
              mid: response.username,
            });
          } catch (agentErr) {
            console.log("Add Agent failed", agentErr);
          }
        }

        const walletResponse = await callWalletApi({
          mid: response.username,
          account_no: accountDetails.accountNumber,
          currency: "INR",
          business_type: selectedRole,
        });

        if (!walletResponse?.message) {
          throw new Error("Wallet creation failed");
        }

        /* ✅ BOTH SUCCESS */
        showPopupMessage(
          `FULL ONBOARDING SUCCESS 🎉
User ID: ${response.user_id}
Username: ${response.username}
password: ${response.password}
Wallet: ${walletResponse.message}`,

          "success",
          "/OnboardingBasicDetails"
        );
      } catch (walletErr) {
        showPopupMessage(
          `Merchant created successfully
But wallet creation failed`,
          "error"
        );
      }
    } catch (err) {
      showPopupMessage("Full onboarding failed", "error");
    } finally {
      setFullLoading(false);
    }
  };

  /* ================= HALF ONBOARDING ================= */
  // const handleSubmithalf = async () => {
  //   if (!selectedRole || !parentId) {
  //     showPopupMessage("Please select role & parent", "error");
  //     return;
  //   }

  //   setHalfLoading(true);

  //   try {
  //     const formData = new FormData();

  //     const { basicDetails, uploadDocuments } = merchantFormData;

  //     formData.append("username", basicDetails.username);
  //     formData.append("role", selectedRole);
  //     formData.append("onboardingStatus", "HALF");
  //     formData.append("createdBy", userId);

  //     /* ---- UPLOAD DOCUMENTS (HALF) ---- */
  //     const fileKeys = [
  //       "aadhaarBack",
  //       "aadhaarFront",
  //       "panCard",
  //       "passbookOrChequeBook",
  //       "selfieWithDocuments",
  //       "selfieWithSalesPerson",
  //       "shopPhoto",
  //       "signaturePhoto",
  //     ];

  //     fileKeys.forEach((key) => {
  //       if (uploadDocuments?.[key] instanceof File) {
  //         formData.append(`kycFiles[${key}]`, uploadDocuments[key]);
  //       }
  //     });

  //     const response = await callApi(formData);

  //     if (response?.user_id || response?.error_code === "DMT024") {
  //       showPopupMessage(
  //         response.message || "Half onboarding completed",
  //         "success",
  //         "/OnboardingBasicDetails"
  //       );
  //     }
  //   } catch (err) {
  //     showPopupMessage("Half onboarding failed", "error");
  //   } finally {
  //     setHalfLoading(false);
  //   }
  // };

  return (
    <div className="h-full bg-[#EEF1F5] p-4">
      <div className="bg-white rounded-xl p-6 shadow-sm">

        <h2 className="text-lg font-semibold text-center text-[#0A2A4F] mb-6">
          MAPPING COMMISSION
        </h2>

        <NetworkRole
          initialRole={formDataFromTable?.role}
          initialIds={formDataFromTable?.parentId}
          roleSelected={(data) => {
            setSelectedRole(data.role);
            setParentId(
              data.selectedIds.asmId ||
              data.selectedIds.distributorId ||
              data.selectedIds.masterDistributorId
            );
          }}
        />

        {showPopup && (
          <Popup
            message={popupMessage}
            type={popupType}
            navigateTo={navigateTo}
            onClose={() => setShowPopup(false)}
          />
        )}

        <div className="flex flex-col md:flex-row gap-4 mt-8">

          {/* <Button
            onClick={handleSubmithalf}
            disabled={halfLoading || fullLoading || isVideoUploaded}
            fullWidth
            className="bg-[#0A2A4F] text-white rounded-lg"
            label={
              halfLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Processing...
                </span>
              ) : (
                "Half Onboarding"
              )
            }
          /> */}

          <Button
            onClick={handleSubmitfull}
            // disabled={fullLoading || halfLoading || !isVideoUploaded}
            disabled={fullLoading}
            fullWidth
            className="bg-[#0A2A4F] text-white rounded-lg"
            label={
              fullLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Submitting...
                </span>
              ) : (
                "Full Onboarding"
              )
            }
          />

        </div>
      </div>
    </div>
  );
};

export default MappingCommission;

